import { useState, useEffect } from "react"
import { Alert, Stack } from '@mui/material';
import Modal from '../comun/VentanaModal.jsx'
import { getCombos } from '../componentes/api.js';

const Alertas =()=>{
  const [idProyecto, setIdProyecto] = useState('')
  const [proyectos, setProyectos] = useState([]);

  /** Para el manejo de la ventana de mensajes modal**/
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleClose = () => setShow(false);

  const cargarProyectos= async()=>{
    try {
      const response = await getCombos({"Tabla":"proyectos","Campo":""},"cboProyectos")
      setProyectos(response.data)
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al cargar los Proyectos", error])
    }
  }

  const mostrarMsg = (msg)=>{
    setMsg(msg)
    setShow(true)
  }

  useEffect(() =>{
    cargarProyectos();
    
  },[]);

  return(
    <div className="container">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="success"><strong>Menu de Alertas</strong></Alert>
        </Stack>
      </div>

      <div className="container-fluid card shadow mt-2 mb-3">
        <div className="form-floating mb-2 mt-2">
          <select
            type="text" 
            className="form-control" 
            name='idProyecto' 
            value={idProyecto} 
            onChange={(event) =>{setIdProyecto(event.target.value);}}
          >
            <option key='0' value='0'>Por favor seleccione un Proyecto...</option>
            {proyectos.map((reg) => {
              return (
                <option key={reg.Id} value={reg.Id} label={reg.Nbre}> {reg.Nbre} </option>
              );
            })}
          </select>
          <label htmlFor="idProyecto">Proyecto Actual</label>
        </div>
      </div>
      <Modal show={show} handleClose={handleClose} msg={msg} />

    </div>
    )
}

export default Alertas